import classNames from 'classnames';
import { forwardRef } from 'react';
import styles from './CustomToggle.module.scss';
import usePresenter from './CustomToggle.presenter';
import { CustomToggleProps } from './CustomToggle.types';

const CustomToggle = forwardRef<HTMLInputElement, CustomToggleProps>((props, ref) => {
  const {
    variantProps,
    isChecked,
    handleChange,
    disabled,
    invalid,
    otherInputProps,
    required,
    content,
  } = usePresenter(props);

  return (
    <label
      className={classNames(
        styles.toggleWrapper,
        {
          [styles.disabled]: disabled,
          [styles.invalid]: invalid,
        },
        props.className,
      )}
      {...variantProps}
    >
      <input
        {...otherInputProps}
        type="checkbox"
        className={styles.input}
        checked={isChecked}
        onChange={handleChange}
        disabled={disabled}
        required={required}
        ref={ref}
        aria-invalid={invalid}
      />
      <div className={styles.toggle}>
        {content}
      </div>
    </label>
  );
});

export default CustomToggle;
